// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { awSignUpPalette } from 'Utils/themes';

// The pricing card of the Figma signup-flow spec: a bordered dark card whose placement
// (under the form on phones, docked beside it on wider screens) is the caller's
const styles = (theme: any) => ({
  planCard: {
    background: awSignUpPalette.cardBackground,
    border: `1px solid ${awSignUpPalette.cardBorder}`,
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    color: awSignUpPalette.bodyText,
  },
  planName: {
    color: awSignUpPalette.mutedText,
  },
  planDetail: {
    color: '#FFFFFF',
  },
  list: {
    width: '100%',
    padding: 0,
  },
  listItemIcon: {
    minWidth: theme.spacing(4),
  },
  flashIcon: {
    marginBottom: theme.spacing(1),
  },
  checkIcon: {
    width: '20px',
  },
  planText: {
    fontSize: '15px',
    fontWeight: 400,
    color: 'inherit',
  },
  planFooter: {
    color: awSignUpPalette.mutedText,
  },
  link: {
    color: awSignUpPalette.link,
  },
});

export default styles;
